/**
 * Kennzahlen eines Bereichs (V-16) - dieselbe Zeile auf jedem Board
 * (Leitlinie 3): aktive Projekte und Fortschritt der laufenden Ziele.
 */
import { goalProgress } from '@/domain/goals/progress';
import { mittel } from '@/domain/stats/zeitraum';
import type { Goal, Project } from '@/domain/types';

export function bereichKennzahlen(projects: Project[], goals: Goal[]): { aktiveProjekte: number; laufendeZiele: number; zielFortschritt: number | null } {
  const laufend = goals.filter((g) => g.status === 'laeuft' || g.status === 'offen');
  const m = mittel(laufend.map(goalProgress));
  return {
    aktiveProjekte: projects.filter((p) => p.status === 'aktiv').length,
    laufendeZiele: laufend.length,
    zielFortschritt: m === null ? null : Math.round(m * 100),
  };
}
